// extracted by mini-css-extract-plugin
export default {"Container":"NumericInput_Container__IEGRJ"};